/*
  Bahimi wishlist — Tier 1, localStorage only (handoff §10, item 5).
  Stores a small record per saved item so the /pages/wishlist grid can render
  client-side without any server state. Keyed by a stable id (product handle).

  Public surface (window.BahimiWishlist):
    .all()            -> array of stored items
    .has(id)          -> boolean
    .toggle(item)     -> boolean (true if now saved)
    .remove(id)       -> void
    .count()          -> number

  DOM hooks:
    [data-wishlist-toggle]  heart button; data-wl-id/title/url/image/price
    [data-wishlist-count]   element whose textContent = saved count
    [data-wishlist-grid]    container on the wishlist page (rendered here)
    [data-wishlist-empty]   empty-state element on the wishlist page
*/
(function () {
  if (window.BahimiWishlist) return;

  var KEY = 'bahimi:wishlist';

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function write(items) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(items));
    } catch (e) {
      /* storage full / disabled — silently no-op */
    }
  }

  function has(id) {
    return read().some(function (it) { return it.id === id; });
  }

  function toggle(item) {
    if (!item || !item.id) return false;
    var items = read();
    var idx = -1;
    for (var i = 0; i < items.length; i++) {
      if (items[i].id === item.id) { idx = i; break; }
    }
    var nowSaved;
    if (idx > -1) {
      items.splice(idx, 1);
      nowSaved = false;
    } else {
      items.unshift(item);
      nowSaved = true;
    }
    write(items);
    sync();
    renderCount();
    renderGrid();
    document.dispatchEvent(new CustomEvent('bahimi:wishlist-change', {
      detail: { saved: nowSaved, item: item, count: items.length }
    }));
    return nowSaved;
  }

  function remove(id) {
    var items = read();
    var removed = items.find(function (it) { return it.id === id; });
    var remaining = items.filter(function (it) { return it.id !== id; });
    write(remaining);
    sync();
    renderCount();
    renderGrid();
    if (removed) {
      document.dispatchEvent(new CustomEvent('bahimi:wishlist-change', {
        detail: { saved: false, item: removed, count: remaining.length }
      }));
    }
  }

  var API = {
    all: read,
    has: has,
    toggle: toggle,
    remove: remove,
    count: function () { return read().length; }
  };
  window.BahimiWishlist = API;

  /* --- keep every heart button in sync with storage --- */
  function sync() {
    var saved = read();
    var ids = {};
    saved.forEach(function (it) { ids[it.id] = true; });
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var on = !!ids[btn.getAttribute('data-wl-id')];
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function renderCount() {
    var n = read().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
    });
  }

  function itemFromButton(btn) {
    return {
      id: btn.getAttribute('data-wl-id'),
      title: btn.getAttribute('data-wl-title') || '',
      url: btn.getAttribute('data-wl-url') || '',
      image: btn.getAttribute('data-wl-image') || '',
      price: btn.getAttribute('data-wl-price') || ''
    };
  }

  /* --- wishlist page grid (client-rendered) --- */
  function renderGrid() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    var empty = document.querySelector('[data-wishlist-empty]');
    var items = read();

    if (!items.length) {
      grid.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;

    grid.innerHTML = items.map(function (it) {
      var img = it.image
        ? '<img src="' + escapeAttr(it.image) + '" alt="" loading="lazy">'
        : '';
      return (
        '<li class="bh-wl-card">' +
          '<a class="bh-wl-card__media" href="' + escapeAttr(it.url) + '">' + img + '</a>' +
          '<button type="button" class="bh-wl-card__remove" data-wishlist-remove="' + escapeAttr(it.id) + '" aria-label="Remove ' + escapeAttr(it.title) + ' from wishlist">&times;</button>' +
          '<div class="bh-wl-card__info">' +
            '<a class="bh-wl-card__title" href="' + escapeAttr(it.url) + '">' + escapeHtml(it.title) + '</a>' +
            '<span class="bh-wl-card__price">' + escapeHtml(it.price) + '</span>' +
          '</div>' +
        '</li>'
      );
    }).join('');
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function escapeAttr(s) { return escapeHtml(s); }

  /* --- events --- */
  document.addEventListener('click', function (e) {
    var toggleBtn = e.target.closest('[data-wishlist-toggle]');
    if (toggleBtn) {
      e.preventDefault();
      toggle(itemFromButton(toggleBtn));
      return;
    }
    var removeBtn = e.target.closest('[data-wishlist-remove]');
    if (removeBtn) {
      e.preventDefault();
      remove(removeBtn.getAttribute('data-wishlist-remove'));
    }
  });

  /* storage event — keep multiple tabs consistent */
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) { sync(); renderCount(); renderGrid(); }
  });

  function init() {
    sync();
    renderCount();
    renderGrid();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
